export const suppressEmployerOnboardingBankInfo = false;
export const suppressInviteEmailLink = false;
export const validateEmployeeEmailLength = false;
export const disableEmployeeEdit = false;
export const employerCustodianInfoTemplate = "AllegacyOnboardingInfo";
export const displayOnboardingBankInformation = true;
export const displayBankAccountHolds = true;
